(function () {
  'use strict';

  angular.module('app').component('saleChannelDetail', saleChannelDetail());

  function saleChannelDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSaleChannelSaved: '&',
        onSaleChannelCanceled: '&',
        company: '<',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: SaleChannelDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/sale-channels/sale-channel-detail/sale-channel-detail.component.html',
    };
  }

  SaleChannelDetailComponent.$inject = ['UtilService', 'SaleChannelService'];

  function SaleChannelDetailComponent(UtilService, SaleChannelService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    let fieldsDefinition = [
      'name',
      'description',
      'is_channel',
      'is_source',
      'is_website',
      'website_id',
      'user_id',
    ];

    vm.$onInit = function () {
      if (vm.item.id) {
        // View / Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          is_channel: false,
          is_source: false,
          is_website: false,
        };
      }
    };

    // public methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editSaleChannel();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    vm.editSaleChannel = function () {
      vm.editMode = true;
      vm.viewMode = false;
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.openTranslations = function () {
      SaleChannelService.openSaleChannelTranslations(vm.item, vm.additionalLanguages);
    };

    // Create/Update
    vm.saveSaleChannel = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        if (!vm.item.is_channel) {
          vm.item.is_website = false;
          vm.item.website_id = '';
        }

        vm.sendingForm = true;
        SaleChannelService.saveSaleChannel(vm.item, vm.defaultLanguage).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // success
            // setItemOptions(response); // use only if keep in the same page
            vm.onSaleChannelSaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onSaleChannelCanceled();
    };
  }
})();
